const loadItems = (button) => {
  const totalPages = parseInt($('[data-total-pages]').val());
  let currentPage = parseInt($('[data-current-page]').val());
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;
  const nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  const nextUrlScroll = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPageScroll);
  $('[data-current-page]').val(currentPage);

  button.setAttribute("disabled", "");
  button.classList.add('loading');

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.load-more-grid').append($(responseHTML).find('.load-more-grid').html());
      // Only initialize color swatches for newly loaded content
      initColorSwatchesForNewContent();
    },
    complete: function() {
      if (currentPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPage != totalPages) {
          scollData.querySelector('input[data-next-url]').dataset.nextUrl =  nextUrlScroll;
          scollData.querySelector('input[data-next-url]').value =  nextUrlScroll;
          scollData.querySelector('input[data-current-page]').dataset.currentPage =  currentPage;
          scollData.querySelector('input[data-current-page]').value =  currentPage;
        }
        button.removeAttribute("disabled");
        button.classList.remove('loading');
        if (currentPage == totalPages) {
          button.remove();
        }
      } 
    }
  })
}

// Optimized: Only initialize swatches for new content
const initColorSwatchesForNewContent = () => {
  // Only target newly loaded color swatch wrappers
  document.querySelectorAll('.load-more-grid .js-color-swatches-wrapper').forEach((wrapper) => {
    if (!wrapper.hasAttribute('data-swatches-initialized')) {
      wrapper.setAttribute('data-swatches-initialized', 'true');
      wrapper.querySelectorAll('.js-color-swatches input').forEach((input) => {
        input.addEventListener('click', handleColorSwatchClick);
      });
    }
  });
};

// Extract the click handler to avoid recreating it
const handleColorSwatchClick = (event) => {
  const wrapper = event.currentTarget.closest('.js-color-swatches-wrapper');
  const primaryImage = wrapper.querySelector('.media--first');
  const secondaryImage = wrapper.querySelector('.media--second');
  const handleProduct = wrapper.dataset.product;

  if (event.currentTarget.checked && primaryImage) {
    wrapper
      .querySelector('.js-color-swatches-link')
      .setAttribute('href', event.currentTarget.dataset.variantLink);
    const currentColor = event.currentTarget.value;

    jQuery.getJSON(
      window.Shopify.routes.root + `products/${handleProduct}.js`,
      function (product) {
        const variant = product.variants.filter(
          (item) =>
            item.featured_media != null &&
            item.options.includes(currentColor)
        )[0];
        if (variant) {
          const newPrimaryImage = createImageElement(
            variant['featured_media'],
            primaryImage.className,
            primaryImage.sizes,
            product.title
          );

          if (newPrimaryImage.src !== primaryImage.src) {
            let flag = false;
            if (secondaryImage) {
              const secondaryImagePathname = new URL(secondaryImage.src)
                .pathname;
              const newPrimaryImagePathname = new URL(newPrimaryImage.src)
                .pathname;

              if (secondaryImagePathname == newPrimaryImagePathname) {
                primaryImage.remove();
                secondaryImage.classList.remove('media--second');
                secondaryImage.classList.add('media--first');
                flag = true;
              }
            }
            if (flag == false) {
              primaryImage.animate(
                { opacity: [1, 0] },
                { duration: 200, easing: 'ease-in', fill: 'forwards' }
              ).finished;
              setTimeout(function () {
                primaryImage.replaceWith(newPrimaryImage);
                newPrimaryImage.animate(
                  { opacity: [0, 1] },
                  { duration: 200, easing: 'ease-in' }
                );
                if (secondaryImage) {
                  secondaryImage.remove();
                }
              }, 200);
            }
          }
        }
      }
    );
  }
};

// Optimized: Single observer instance
let infiniteScrollObserver = null;

const initInfiniteScroll = () => {
  if (infiniteScrollObserver) {
    infiniteScrollObserver.disconnect();
  }
  
  infiniteScrollObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(entry.target);
        }
      });
    }
  );

  document.querySelectorAll('.js-infinite-scroll').forEach((spinner) => {
    infiniteScrollObserver.observe(spinner);
  });
}

function loadMore() {  
  document.querySelectorAll('.js-load-more').forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    }
  });

  initInfiniteScroll();
}

(function () {
  loadMore();
})();